import _salmi from './../assets/json/salmi.json'

// add-or-remove a verse from favorites
export function toggleFavoriteVerse(psalm, verse) {
    const entry = `${psalm}-${verse}`;
    const verses = (localStorage.getItem('favoriteVerses') || '')
        .split(',')
        .filter(Boolean); // remove 'falsy' (null, undefined, ...) el.
    
    const newList = verses.includes(entry)
        ? verses.filter(i => i !== entry)
        : [...verses, entry];
    
    localStorage.setItem('favoriteVerses', newList.join(','));
    return newList;
}

/** @description this return a key-value object formatted like this:
 * 
 * 
 *  {
 *    3: {
 *      5: "...",
 *      ...
 *    }
 *  }
 * 
 * Used to get a schematical rapresentation of favorite verse by psalm
 */
export function getFavoriteVersesByPsalm() {
    const psalm_list = _salmi.items;
    const favRaw = localStorage.getItem('favoriteVerses') || '';
    const favs = favRaw.split(',').filter(Boolean); // ['1-1','2-1']

    // 1. raggruppo versi per salmo
    const f = {};
    favs.forEach((item) => {
        const [psalm, verse] = item.split('-'); // [psalm, verse]
        if (!f[psalm]) f[psalm] = {};
        f[psalm][verse] = psalm_list[psalm-1].content[verse-1];
    });
    return f;
}

// restituisce i numeri dei versi favoriti per un salmo
export function getFavVerseByPsalm(psalm) {
    const favRaw = localStorage.getItem('favoriteVerses') || '';
    const favs = favRaw.split(',').filter(Boolean);
    return favs 
        .filter(item => item.startsWith(`${psalm}-`))
        .map(entry => parseInt(entry.split('-')[1], 10));
}

export function getFavoritePsalm() {
    let fav = localStorage.favoritePsalms;
    if(fav) {
        fav = fav.split(',') // ['2','5']
        return fav
    } else { return [] }
}


// return total favorites in Number (psalms + verses)
export function countFavorites() {
    let psalms = localStorage.getItem('favoritePsalms') || 0;
    let verses = localStorage.getItem('favoriteVerses') || 0;

    if(psalms) psalms = psalms.split(',').length;
    if(verses) verses = verses.split(',').length;

    return psalms + verses
}

export function isVerseFavorite(psalm, verse) {
    const favRaw = localStorage.getItem('favoriteVerses') || '';
    const favs = favRaw.split(',').filter(Boolean);
    return favs.includes(`${psalm}-${verse}`);
}

// export function loadFavoritesVerses() {
//   const raw = localStorage.getItem('favoriteVerses') || '';
//   return raw
//     .split(',')
//     .filter(Boolean)
//     .reduce((acc, entry) => {
//       const [psalm, verse] = entry.split('-').map(Number);
//       acc[psalm] = acc[psalm] || [];
//       acc[psalm].push(verse);
//       return acc;
//     }, {});
// }